import ApiService from '@/services/api';
import Purchase from '@/entities/Purchase';
import { EntityBuilder } from '@decahedron/entity';

let instance: PurchaseService = null;

export default class PurchaseService {
    protected ownPurchases: Purchase[] = null;

    apiService: ApiService = null;

    purchasesList: Purchase [] = null;

    get own(): Purchase[] {
        if (!this.ownPurchases) {
            this.getOwn()
                .then((purchases) => {
                    this.ownPurchases = purchases;
                });
        }

        return this.ownPurchases || [];
    }

    constructor() {
        if (!instance) {
            this.apiService = new ApiService();
            instance = this;
        }

        return instance;
    }

    get list() {
        if (!this.purchasesList) {
            this.getList().then((purchases) => {
                this.purchasesList = purchases;
            });
        }

        return this.purchasesList || [];
    }

    getList() {
        return this.apiService.get('purchases')
            .then((response) => EntityBuilder.buildMany<Purchase>(Purchase, response.data));
    }

    getOwn() {
        return this.apiService.get('purchases/own')
            .then((response) => EntityBuilder.buildMany<Purchase>(Purchase, response.data));
    }

    addPurchase(carId: string) {
        const data = new FormData();
        data.append('car_id', carId);
        return this.apiService.post('purchases', data)
            .then((response) => {
                const purchase = EntityBuilder.buildOne(Purchase, response.data);
                if (this.ownPurchases) {
                    this.ownPurchases.push(purchase);
                }
                return purchase;
            });
    }

    remove(purchase: Purchase) {
        return this.apiService
            .delete(`purchases/${purchase.id}`)
            .then(() => {
                for (let n = 0; n < this.purchasesList.length; n += 1) {
                    if (this.purchasesList[n].id === purchase.id) {
                        this.purchasesList.splice(n, 1);
                        break;
                    }
                }
            });
    }
}
